import { ResourceType } from "@core/shared/types";

export function useResourceTheme() {
  const getResourceTheme = (type: ResourceType) => {
    switch (type) {
      case ResourceType.Video:
      case ResourceType.Youtube:
        return {
          gradient: "from-red-500 to-red-600",
          lightGradient:
            "from-red-100 to-red-300 dark:from-red-950 dark:to-red-900",
          border: "border-red-200 dark:border-red-900",
          shadow: "shadow-red-200/50 dark:shadow-none",
          icon: "🎥",
          iconBg: "bg-red-500",
        };
      case ResourceType.Pdf:
        return {
          gradient: "from-orange-500 to-orange-600",
          lightGradient:
            "from-orange-100 to-orange-300 dark:from-orange-950 dark:to-orange-900",
          border: "border-orange-200 dark:border-orange-900",
          shadow: "shadow-orange-200/50 dark:shadow-none",
          icon: "📄",
          iconBg: "bg-orange-500",
        };
      case ResourceType.Assessment:
        return {
          gradient: "from-green-500 to-green-600",
          lightGradient:
            "from-green-100 to-green-300 dark:from-green-950 dark:to-green-900",
          border: "border-green-200 dark:border-green-900",
          shadow: "shadow-green-200/50 dark:shadow-none",
          icon: "📝",
          iconBg: "bg-green-500",
        };
      case ResourceType.Audio:
        return {
          gradient: "from-purple-500 to-purple-600",
          lightGradient:
            "from-purple-50 to-purple-100 dark:from-purple-950 dark:to-purple-900",
          border: "border-purple-200 dark:border-purple-900",
          shadow: "shadow-purple-200/50 dark:shadow-none",
          icon: "🎵",
          iconBg: "bg-purple-500",
        };
      case ResourceType.Image:
        return {
          gradient: "from-emerald-500 to-emerald-600",
          lightGradient:
            "from-emerald-100 to-emerald-400 dark:from-emerald-950 dark:to-emerald-900",
          border: "border-emerald-200 dark:border-emerald-900",
          shadow: "shadow-emerald-200/50 dark:shadow-none",
          icon: "🖼️",
          iconBg: "bg-emerald-500",
        };
      case ResourceType.Url:
        return {
          gradient: "from-cyan-500 to-cyan-600",
          lightGradient:
            "from-cyan-50 to-cyan-100 dark:from-cyan-950 dark:to-cyan-900",
          border: "border-cyan-200 dark:border-cyan-900",
          shadow: "shadow-cyan-200/50 dark:shadow-none",
          icon: "🔗",
          iconBg: "bg-cyan-500",
        };
      default:
        return {
          gradient: "from-blue-500 to-blue-600",
          lightGradient:
            "from-blue-50 to-blue-100 dark:from-blue-950 dark:to-blue-900",
          border: "border-blue-200 dark:border-blue-900",
          shadow: "shadow-blue-200/50 dark:shadow-none",
          icon: "📁",
          iconBg: "bg-blue-500",
        };
    }
  };

  return {
    getResourceTheme,
  };
}
